import APIError from '../APIError';
class NotificationsError extends APIError {
    constructor(code, details = null) {
        super(code, 'NotificationsError', details);
    }
}
export default NotificationsError;
